import React, { useState, useRef, useCallback, useEffect } from 'react';
import { translate } from 'react-i18next';
import { trendingGifFetch, searchGifFetch } from '../../../actions/index';
import { Icon } from '../Icon';
import cx from '../../../styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const FetchGIF = (props) => {
    const { t } = props;
    const [gifData, setGifData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('')
    const [next, setNext] = useState('');
    const [hasMore, setHasMore] = useState(false);
    const [eventAdded, setEventAdded] = useState(false)
    const [noGifFound, setNoGifFound] = useState(false);

    useEffect(() => {
        setNext('')
    }, [searchTerm])

    const trendingGifCall = (pagination, next) => {
        props.trendingGifFetch(next)
            .then(async (response) => {
                if (response && response.data && response.data.results) {
                    if (pagination) {
                        setGifData(prevGif => {
                            return [...new Set([...prevGif, ...response.data.results])]
                        })
                    } else {
                        setGifData([...response.data.results]);
                    }
                    setNext(response.data.next); setNoGifFound(false); setHasMore(response.data.next.length > 0)
                } else {
                    setNoGifFound(true)
                }
            })
            .catch((err) => {
                console.log("We have err after GIF api call", err);
                setNoGifFound(true)
            })
    }

    const searchGifCall = (query, pagination, next) => {
        props.searchGifFetch(query, pagination ? next : '')
            .then(async (response) => {
                if (response && response.data && response.data.results) {
                    if (pagination) {
                        setGifData(prevGif => {
                            return [...new Set([...prevGif, ...response.data.results])]
                        })
                    } else {
                        setGifData([])
                        setGifData([...response.data.results]);
                    }
                    setNoGifFound(false); setNext(response.data.next); setHasMore(response.data.next.length > 0)
                } else {
                    setNoGifFound(true)
                }
            })
            .catch((err) => {
                console.log("We have err after GIF api call", err);
                setNoGifFound(true)
            })
    }

    if (props.showGIF && !gifData.length && !searchTerm.length) {
        trendingGifCall(false, '')
    }
    const onGifSelect = (gifId, gifURL) => {
        props.handleSelect(gifId, gifURL)
        setGifData([]); setSearchTerm(''); setEventAdded(false)
    }

    const observer = useRef()
    const lastGifElementRef = useCallback(node => {
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore && !searchTerm.length) {
                trendingGifCall(true, next)
            } else if (entries[0].isIntersecting && hasMore && searchTerm.length > 0) {
                searchGifCall(searchTerm, true, next)
            }
        })
        if (node) observer.current.observe(node)
    })

    const gifSearch = () => {
        if (!eventAdded) {
            setEventAdded(true)
            const searchInput = document.querySelector('.search-gif')
            let timeout = setTimeout(function () { }, 0)
            if (searchInput) {
                searchInput.addEventListener('keyup', e => {
                    clearTimeout(timeout);
                    setSearchTerm(e.target.value)
                    timeout = setTimeout(() => {
                        if (e.target.value.length) {
                            searchGifCall(e.target.value, false, '')
                        } else {
                            trendingGifCall(false, '')
                        }
                    }, 500)
                })
            }
        }
    }

    return (
        props.showGIF && gifData &&
        <div className={cx('gif-wrapper')}>
            <div className={cx('gif-preview')}>
                {
                    noGifFound ?
                        <div className={cx('no-gif-found')}>
                            <Icon name="no-gif-regular" />
                            <p>{t('no_gif_found')}</p>
                        </div>
                        :
                        gifData && gifData.map((data, key) => {
                            if (data.media[0] && data.media[0].gif && data.media[0].gif.url) {
                                if (gifData.length === key + 1) {
                                    return (
                                        <div className={cx('wrap')} key={key} ref={lastGifElementRef}>
                                            <img src={`${data.media[0].gif.url}`} ref={lastGifElementRef} key={key} onClick={() => { onGifSelect(data.id, data.media[0].gif.url) }} className={cx('gif')}></img>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div className={cx('wrap')} key={key}>
                                            <img src={`${data.media[0].gif.url}`} ref={lastGifElementRef} key={key} onClick={() => { onGifSelect(data.id, data.media[0].gif.url) }} className={cx('gif')}></img>
                                        </div>
                                    )
                                }
                            }
                        })
                }
            </div>
            <div className={cx('bottom-wrap')}>
                <div className={cx('search-wrap')}>
                    <Icon name="search-icon-regular" />
                    <input type="text" className={cx('search-gif')} placeholder={t('search_gif')} onClick={gifSearch} ></input>
                </div>
                <div className={cx('close-gif')} onClick={() => { props.handleGIFToggle(); setGifData([]); setSearchTerm(''); setEventAdded(false) }}>
                    {t('close_gif')}
                </div>
            </div>
        </div>
    )
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        trendingGifFetch,
        searchGifFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(FetchGIF));
